import './HeroSection.scss'
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";


export function HeroSection(props) {
    const navigate = useNavigate();
    const [typewriter, setTypeWriteContent] = useState(`Unlock the full potential of your data and technology with our cutting-edge AI, Machine Learning, Big Data, and Software Development services. From data-driven insights and advanced analytics to robust software applications, we provide end-to-end solutions tailored to your unique needs. Our team of experts leverages the latest technologies to deliver scalable, secure, and innovative solutions that drive growth and efficiency.`)
    const content = [
        // Same substring at the start will only be typed out once, initially
        // "welcome to byteGPT",
        1000, // wait 1s before replacing "Mice" with "Hamsters"
        typewriter,
    ];
    const searchSubmit = (e) => {
        e.preventDefault();
    };

    const handleRegister = () => {
        if (props.searchText == "") return;
        navigate("/register?email=" + props.searchText);
    };


    return (
        <div className='HeroSection'>
            <div className="home-title1">

                <img className="poster-img" src="/images/home-frame.jpg" alt="" />
                <p className="Heading">  <span style={{ color: 'blue' }}> Transforming Ideas </span>  into Impactful Solutions with AI, Big Data, and Software</p>

            </div>

            <div className="homepage-paragraph">

                <p className="paragraph">
                    Award-winning and trusted by industry-leading institutions. We collaborate with leading start-ups and organisations

                    {/* <span className="learn-more">Learn more...</span> */}
                </p>

                {/* <form className="search-btn" onSubmit={(event) => searchSubmit(event)}>
                    <input
                        style={{ fontSize: "20px", border: "none" }}
                        type="search"
                        placeholder="Enter your email"
                        onChange={(event) => props.setSearchText(event.target.value)}
                        value={props.searchText}
                    />
                    <button type="submit" onClick={handleRegister}>
                        Register
                    </button>
                </form> */}
            </div>

            <div className="company-details">
                <div className="company-description">
                    
                <p>
                    {typewriter}
                </p>
                    {/* <p>
                        {true ?
                            <TypeAnimation
                                sequence={content}
                                wrapper="span"
                                speed={50}
                                style={{ fontSize: "1.2em", display: "inline-block" }}
                                repeat={0}
                            /> : ''
                        }
                    </p> */}
                </div>
                {/* <div className="company-video">
                    <video src="./videos/ai.mp4" controls></video>
                </div> */}
            </div>
        </div>

    );
}